import React, { useState } from "react";
import { pageTitle } from "../../helpers/PageTitle";
import BreadcrumbStyle3 from "../Breadcrumb/BreadcrumbStyle3";
import Section from "../Section";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import Spacing from "../Spacing";
import Sidebar from "../Sidebar/Workup";
import FaqSectionStyle4 from "../FaqSection/FaqSectionStyle4";
import Post from "../Post";
import styled from "styled-components";
import FeaturesSectionStyle5 from "../Feature/FeaturesSectionStyle5";
import { Helmet } from "react-helmet";
const relatedBlog = [
  {
    title:
      "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
    thumbUrl: "/images/blog/post_1.jpeg",
    date: "March 12",
    btnText: "Learn More",
    href: "/blog/blog-details",
  },
];
const faqData = [
  {
    title: "What is a complete fertility workup ?",
    content:
      "A complete fertility workup is a comprehensive evaluation of both partners' reproductive health to identify potential causes of infertility. It includes a series of diagnostic tests, physical examinations, and medical history reviews to provide a thorough understanding of factors affecting fertility and to develop an effective treatment plan.",
  },
  {
    title: "What tests are included in a complete fertility workup ?",
    content:
      "A complete fertility workup typically includes, for women : blood tests, ultrasound scans, HSG, and possibly laparoscopy or hysteroscopy, and for men : semen analysis, blood tests, and possibly a physical examination or ultrasound.",
  },
  {
    title: "How long does a complete fertility workup take ?",
    content:
      "The duration of a complete fertility workup can vary depending on the specific tests required and the individual's health condition. Generally, the workup can take upto 4 weeks approximately to complete, as some tests are performed at specific times during a woman’s menstrual cycle. Your fertility specialist will provide a detailed timeline based on your personalized evaluation plan.",
  },
  {
    title: "Why is a complete fertility workup important ?",
    content:
      "A complete fertility workup is essential because it helps identify the underlying causes of infertility, allowing for a targeted and effective treatment plan. By understanding the specific factors affecting fertility, our specialists can recommend the most appropriate interventions, increasing the chances of successful conception and a healthy pregnancy.",
  },
  {
    title:
      "What should I expect during my first visit for a complete fertility workup ?",
    content:
      "During your first visit, you’ll receive a comprehensive medical history review, a detailed physical examination, and initial test recommendations to kickstart your fertility evaluation. You’ll also get a clear overview of the entire workup process, including what additional tests might be needed, the timeline for results, and the next steps for your treatment plan.",
  },
];
const featureListData = [
  {
    iconUrl: "/images/home_4/compassion.svg",
    title: "Advance Infrastructure",
    subTitle:
      "We understand that seeking medical care can be a stressful experience, and we strive to provide world-class infrastructure to achieve the best results for our patients.",

    subTitles:
      "'I got the best possible treatment and owe it to the Doctor and Staff! I sincerely followed his diagnosis and recommended treatment and it worked wonders! Very caring and concerned!'",
    ratingNumber: "5",
    Name: "Kavita Sinha",
  },
  {
    iconUrl: "/images/home_4/excellence.svg",
    title: "High IVF Success Rate",
    subTitle:
      "We believe in continuously updating our technologies and improving our skills and resources to ensure that we deliver the quality care possible. We are happy and proud to say that we have been providing excellent IVF success rates.",

    subTitles:
      "'The Gynecologist took a great care  of me throught out my pregnacies. would definitely recommend others.'",
    ratingNumber: "4.5",
    Name: "Preeti Singh",
  },
  {
    iconUrl: "/images/home_4/integrity.svg",
    title: "Cost Effective",
    subTitle: `We believe in practicing medicine with integrity and honesty. We have designed comprehensive, highly affordable packages with the aim of providing advanced fertility services to as many people as possible.`,
    subTitles:
      "'ONe of my freind suggest this gynecologist after we had some trouble conceiving children.But now after their effective treatment I am very happy'",
    ratingNumber: "4.0",
    Name: "Sonia Mehra",
  },
  {
    iconUrl: "/images/home_4/respect.svg",
    title: "Transparency",
    subTitle:
      "We treat all individuals with respect, compassion, and kindness, regardless of their background, beliefs, or circumstances. We are transparent in our communications and decision-making processes, and we always put our patients' interests first.",
    subTitles:
      "'I got the best possible treatment and owe it to the Doctor and Staff! I sincerely followed his diagnosis and recommended treatment and it worked wonders! Very caring and concerned!'",
    ratingNumber: "5",
    Name: "Kavita Sinha",
  },
  {
    iconUrl: "/images/home_4/teamwork.svg",
    title: "Support",
    subTitle:
      "We believe in providing a comprehensive support system, thus providing everything from basic treatment to advanced care. We have a highly skilled team to ensure in-depth investigations, perfect individualized treatment plans, advanced endoscopic fertility-enhancing surgeries, the highest quality fertility treatment, and excellent management of high-risk pregnancies.",
    subTitles:
      "'The Gynecologist took a great care  of me throught out my pregnacies. would definitely recommend others.'",
    ratingNumber: "4.5",
    Name: "Preeti Singh",
  },
];

export default function CompleteWorkup() {
  const [activeFaq, setActiveFaq] = useState(0);

  return (
    <>
      <Helmet>
        <title>Complete Fertility Workup & Diagnosis</title>
        <meta name="description" content="Comprehensive fertility testing for both partners to identify the root cause and personalize your treatment plan." />
        <meta name="keywords" content="fertility workup, fertility tests, infertility diagnosis, reproductive health checkup" />
        <link rel="canonical" href="https://jabalpurivfcentre.com/Complete-Workup" />
      </Helmet>

      <div className="cs_workup_new">
        {/* 1. Hero Banner */ }
        <section className="cs_workup_hero" style={ { backgroundImage: 'url(/images/Complete-Workup.jpeg)', backgroundPosition: 'center center', backgroundSize: '100% 100%', minHeight: '650px', display: 'flex', alignItems: 'center' } }>
          <div className="container">
            <h1>Important things to know about male and female infertility workups</h1>
          </div>
        </section>

        {/* 2. Main Layout (Content + Sidebar) */ }
        <section className="cs_workup_content_wrap">
          <div className="container">
            <div className="row">
              <div className="col-lg-8">

                {/* Restored Date and Social Links */ }
                <div className="cs_blog_details_info">
                  <div className="cs_blog_details_info_left">
                    <div className="cs_blog_details_date">
                      March 12, 2024 | Dr. Archana Srivastava
                    </div>
                  </div>
                  <div className="cs_social_links_wrap" style={ { display: 'flex', alignItems: 'center', gap: '15px' } }>
                    <h2 style={ { margin: 0, fontSize: '18px', color: '#586776' } }>Share:</h2>
                    <div className="cs_mcp_doctor_socials" style={ { margin: 0 } }>
                      <Link to="https://www.facebook.com/PluroJabalpurFertilityAndIVFCentre/" className="cs_mcp_social_btn" target="_blank" rel="noreferrer">
                        <Icon icon="fa6-brands:facebook-f" />
                      </Link>
                      <Link to="https://www.instagram.com/plurojabalpur_ivf/" className="cs_mcp_social_btn" target="_blank" rel="noreferrer">
                        <Icon icon="fa6-brands:instagram" />
                      </Link>
                      <Link to="https://www.youtube.com/@PluroJabalpur_IVF" className="cs_mcp_social_btn" target="_blank" rel="noreferrer">
                        <Icon icon="fa6-brands:youtube" />
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Intro */ }
                <div className="cs_workup_intro">
                  <h2 className="cs_main_heading">Comprehensive Fertility Assessments at Jabalpur Fertility Centre</h2>
                  <p>
                    Understanding the root cause of fertility issues is the essential first step towards effective treatment. At Jabalpur Fertility Centre, recognized as the Best Fertility Clinic in Jabalpur, we are committed to providing thorough and detailed fertility assessments. Our expert team, led by Dr. Archana Shrivastava, the Best IVF Doctor in Jabalpur, utilizes advanced diagnostic techniques to ensure a precise and comprehensive evaluation of your fertility health.
                  </p>
                  <h2>What is a Complete Fertility Workup?</h2>
                  <p>
                    A complete fertility workup is an extensive series of tests and evaluations designed to identify any factors that may be impacting your ability to conceive. This comprehensive approach ensures that we gather all necessary information to develop a tailored treatment plan that addresses your unique needs and circumstances.
                  </p>
                </div>

                {/* Components Grid */ }
                <div className="cs_workup_components">
                  <h2>Components of the Fertility Workup</h2>
                  <div className="cs_workup_components_grid">

                    {/* Card 1 */ }
                    <div className="cs_component_card">
                      <div className="cs_cc_icon">1</div>
                      <div className="cs_cc_title">Detailed Medical History Review</div>
                      <ul className="cs_cc_list">
                        <li><b>Personal Medical History :</b> We review your past medical records, including any previous pregnancies, surgeries, and treatments.</li>
                        <li><b>Family Medical History :</b> Understanding the medical history of your family can help identify any genetic factors or hereditary conditions that might affect fertility.</li>
                        <li><b>Menstrual Cycle Analysis :</b> Detailed tracking of menstrual cycle regularity, duration, and associated symptoms to understand hormonal balance and ovulatory patterns.</li>
                      </ul>
                    </div>

                    {/* Card 2 */ }
                    <div className="cs_component_card">
                      <div className="cs_cc_icon">2</div>
                      <div className="cs_cc_title">Thorough Physical Examination</div>
                      <ul className="cs_cc_list">
                        <li><b>General Health Assessment :</b> A complete physical examination to assess overall health and identify any physical conditions that may affect fertility.</li>
                        <li><b>Reproductive Health Examination :</b> A focused examination of the reproductive organs to detect any abnormalities or signs of conditions such as endometriosis, fibroids, or polycystic ovary syndrome (PCOS).</li>
                      </ul>
                    </div>

                    {/* Card 3 */ }
                    <div className="cs_component_card">
                      <div className="cs_cc_icon">3</div>
                      <div className="cs_cc_title">Comprehensive Hormonal Testing</div>
                      <ul className="cs_cc_list">
                        <li><b>Blood Tests :</b> Blood samples are taken to measure levels of key hormones including FSH, LH, AMH, estrogen, Prolactin, and progesterone, which play crucial roles in the reproductive process.</li>
                        <li><b>Thyroid Function Tests :</b> Evaluating thyroid hormone levels, as thyroid dysfunction can significantly impact fertility.</li>
                      </ul>
                    </div>

                    {/* Card 4 */ }
                    <div className="cs_component_card">
                      <div className="cs_cc_icon">4</div>
                      <div className="cs_cc_title">Advanced Ultrasound Imaging</div>
                      <ul className="cs_cc_list">
                        <li><b>Transvaginal Ultrasound :</b> Provides detailed images of the uterus, ovaries, and fallopian tubes to detect structural abnormalities such as cysts, fibroids, or polyps.</li>
                        <li><b>Antral Follicle Count (AFC) :</b> Assessing the number of follicles in the ovaries to evaluate ovarian reserve and predict response to fertility treatments.</li>
                      </ul>
                    </div>

                    {/* Card 5 */ }
                    <div className="cs_component_card">
                      <div className="cs_cc_icon">5</div>
                      <div className="cs_cc_title">Semen Analysis for Male Partners</div>
                      <ul className="cs_cc_list">
                        <li><b>Sperm Count :</b> Determining the number of sperm present in a semen sample.</li>
                        <li><b>Sperm Motility :</b> Assessing the movement and swimming capabilities of sperm.</li>
                        <li><b>Sperm Morphology :</b> Examining the size and shape of sperm to identify any abnormalities that could affect fertility.</li>
                      </ul>
                    </div>

                    {/* Card 6 */ }
                    <div className="cs_component_card">
                      <div className="cs_cc_icon">6</div>
                      <div className="cs_cc_title">Additional Diagnostic Procedures</div>
                      <ul className="cs_cc_list">
                        <li><b>Hysterosalpingography (HSG) :</b> An X-ray procedure to check the patency of the fallopian tubes and detect any blockages or abnormalities in the uterine cavity.</li>
                        <li><b>Laparoscopy :</b> A minimally invasive surgical procedure to visually examine the pelvic organs and identify conditions like endometriosis or adhesions that might not be detectable through other methods.</li>
                        <li><b>Hysteroscopy :</b> A procedure using a thin, lighted tube to inspect the inside of the uterus for polyps, fibroids, or other abnormalities.</li>
                      </ul>
                    </div>

                  </div>
                </div>

              </div>

              {/* Sidebar */ }
              <div className="col-lg-4">
                <div className="cs_sidebar_sticky">
                  <Sidebar />
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* 5. Treatment Checklist (Full Screen Scrollable) */ }
        <section className="cs_workup_treatment_section" style={ { background: 'linear-gradient(180deg, #fdfdfd 0%, #f9f9f9 100%)' } }>
          <div className="container-fluid" style={ { padding: '0 5%' } }>
            <div className="cs_workup_treatment" style={ { marginTop: '0', background: 'transparent', boxShadow: 'none', padding: '0' } }>
              <div className="cs_treatment_header cs_premium_header">
                <div className="cs_premium_badge" style={ { display: 'inline-block', marginBottom: '15px', color: '#c77842', background: 'rgba(199, 120, 66, 0.1)', padding: '5px 15px', borderRadius: '20px', fontWeight: 'bold' } }>Treatment Plan</div>
                <h3 style={ { fontFamily: '"Playfair Display", serif', fontStyle: 'italic', fontSize: '42px', color: '#1c2b38', marginBottom: '20px' } }>Personalized Approach to Treatment</h3>
                <p style={ { fontSize: '18px', color: '#586776', maxWidth: '800px', margin: '0 auto' } }>Once the complete fertility workup is completed, our team, led by <strong>Dr. Archana Shrivastava</strong>, will analyze the results and develop a personalized treatment plan tailored to your specific needs. This plan may include :</p>
              </div>
              <div className="cs_treatment_list_horizontal">
                <div className="cs_treatment_item">
                  <div className="cs_ti_icon">✓</div>
                  <div className="cs_ti_content">
                    <h4>Lifestyle Modifications</h4>
                    <p>Recommendations on diet, exercise, and stress management to improve overall health and fertility.</p>
                  </div>
                </div>
                <div className="cs_treatment_item">
                  <div className="cs_ti_icon">✓</div>
                  <div className="cs_ti_content">
                    <h4>Medications</h4>
                    <p>Prescribing hormonal treatments or other medications to address specific conditions such as PCOS or thyroid dysfunction.</p>
                  </div>
                </div>
                <div className="cs_treatment_item">
                  <div className="cs_ti_icon">✓</div>
                  <div className="cs_ti_content">
                    <h4>Surgical Interventions</h4>
                    <p>If structural issues are identified, minimally invasive surgical procedures may be recommended to correct abnormalities.</p>
                  </div>
                </div>
                <div className="cs_treatment_item">
                  <div className="cs_ti_icon">✓</div>
                  <div className="cs_ti_content">
                    <h4>Assisted Reproductive Technologies (ART)</h4>
                    <p>For those requiring advanced treatments, options such as IVF Treatment in Jabalpur or IUI may be suggested to enhance the chances of conception.</p>
                  </div>
                </div>
                <div className="cs_treatment_item">
                  <div className="cs_ti_icon">✓</div>
                  <div className="cs_ti_content">
                    <h4>Male Fertility Treatments</h4>
                    <p>For couples where male factor infertility is identified, treatments such as sperm retrieval techniques, medication, or lifestyle changes may be recommended.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 6. Why Choose Us Section */ }
        <section className="cs_workup_features" style={ { overflow: 'hidden' } }>
          <div className="container">
            <div className="cs_section_heading">
              <h2>Why <span>Choose Us</span></h2>
            </div>
          </div>
          <div className="cs_marquee_wrapper">
            <div className="cs_feature_testimonial_grid cs_marquee_content">
              { [...featureListData, ...featureListData].map((item, index) => (
                <div className="cs_ft_card" key={ index }>
                  <div className="cs_ft_header">
                    <div className="cs_ft_icon">
                      <img src={ item.iconUrl } alt={ item.title } />
                    </div>
                    <h3 className="cs_ft_title">{ item.title }</h3>
                  </div>
                  <div className="cs_ft_body">
                    <p className="cs_ft_desc">{ item.subTitle }</p>
                  </div>
                </div>
              )) }
            </div>
          </div>
        </section>

        {/* 7. FAQ Section */ }
        <Section topMd={ 190 } topLg={ 145 } topXl={ 105 } bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <FaqSectionStyle4
            sectionTitle="Frequently Asked <br />Questions"
            data={ faqData }
            faqImgUrl="/images/home_4/faq_img.jpg"
            spiningImgUrl="/images/home_1/about_mini.svg"
          />
        </Section>

        {/* Contact Us Section */}
        <Section topMd={ 60 } topLg={ 40 } topXl={ 20 } bottomMd={ 100 } bottomLg={ 80 } bottomXl={ 60 }>
          <div className="container">
            <div className="cs_ivf_contact_banner" style={ { background: '#c77842', borderRadius: '20px', padding: '60px 50px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '30px' } }>
              <div className="cs_icc_content" style={ { flex: '1', minWidth: '300px' } }>
                <h2 style={ { color: '#fff', fontSize: '36px', marginBottom: '15px', fontWeight: '700' } }>Contact Us</h2>
                <p style={ { color: 'rgba(255,255,255,0.9)', fontSize: '18px', margin: '0', lineHeight: '1.6' } }>
                  If you are considering IVF as a fertility treatment option,
                  contact Jabalpur Fertility Centre today. Our expert team is
                  here to guide you through the process and help you achieve
                  your dream of starting a family.
                </p>
              </div>
              <div className="cs_icc_action">
                <Link to="/contact" className="cs_btn" style={ { background: '#fff', color: '#c77842', padding: '15px 40px', borderRadius: '50px', fontWeight: '600', fontSize: '18px', display: 'inline-flex', alignItems: 'center', textDecoration: 'none', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' } }>
                  <span>Get in Touch</span>
                </Link>
              </div>
            </div>
          </div>
        </Section>

        {/* Related Articles Section */}
        <Section bottomMd={ 200 } bottomLg={ 150 } bottomXl={ 110 }>
          <div className="container">
            <h2 className="mb-0 cs_fs_40 cs_medium">Related Articles</h2>
            <Spacing md="57" />
            <div className="row cs_gap_y_40">
              { [
                {
                  title: "The Importance of Mental Health: Understanding and Managing Anxiety Disorders",
                  thumbUrl: "/images/blog/post_1.jpeg",
                  date: "March 12",
                  btnText: "Learn More",
                  href: "/blog/blog-details",
                }
              ].map((item, index) => (
                <div className="col-xl-12" key={ index }>
                  <Post { ...item } />
                </div>
              )) }
            </div>
          </div>
        </Section>




      </div>
    </>
  );
}
